/*
 * *****************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Tue, Jul 20th 2021, 8:42:41 pm
 *
 * *****************************************************
 */

import { DividerContainer } from './styles';

/**
 * Divider used in sign in and sign up form
 */
const Divider = () => (
  <DividerContainer>
    <hr />
    <span>OR</span>
    <hr />
  </DividerContainer>
);

export default Divider;
